/* tslint:disable */
/* eslint-disable */
/**
 * SONeu.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AssetExpenseSummaryResponse
 */
export interface AssetExpenseSummaryResponse {
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseSummaryResponse
     */
    totalExpenses: number;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseSummaryResponse
     */
    totalIncome: number;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseSummaryResponse
     */
    seizableAmount: number;
    /**
     * 
     * @type {number}
     * @memberof AssetExpenseSummaryResponse
     */
    remainingIncome: number;
    /**
     * 
     * @type {boolean}
     * @memberof AssetExpenseSummaryResponse
     */
    isIncomeAvailable: boolean;
}

/**
 * Check if a given object implements the AssetExpenseSummaryResponse interface.
 */
export function instanceOfAssetExpenseSummaryResponse(value: object): value is AssetExpenseSummaryResponse {
    if (!('totalExpenses' in value) || value['totalExpenses'] === undefined) return false;
    if (!('totalIncome' in value) || value['totalIncome'] === undefined) return false;
    if (!('seizableAmount' in value) || value['seizableAmount'] === undefined) return false;
    if (!('remainingIncome' in value) || value['remainingIncome'] === undefined) return false;
    if (!('isIncomeAvailable' in value) || value['isIncomeAvailable'] === undefined) return false;
    return true;
}

export function AssetExpenseSummaryResponseFromJSON(json: any): AssetExpenseSummaryResponse {
    return AssetExpenseSummaryResponseFromJSONTyped(json, false);
}

export function AssetExpenseSummaryResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): AssetExpenseSummaryResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'totalExpenses': json['totalExpenses'],
        'totalIncome': json['totalIncome'],
        'seizableAmount': json['seizableAmount'],
        'remainingIncome': json['remainingIncome'],
        'isIncomeAvailable': json['isIncomeAvailable'],
    };
}

export function AssetExpenseSummaryResponseToJSON(json: any): AssetExpenseSummaryResponse {
    return AssetExpenseSummaryResponseToJSONTyped(json, false);
}

export function AssetExpenseSummaryResponseToJSONTyped(value?: AssetExpenseSummaryResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'totalExpenses': value['totalExpenses'],
        'totalIncome': value['totalIncome'],
        'seizableAmount': value['seizableAmount'],
        'remainingIncome': value['remainingIncome'],
        'isIncomeAvailable': value['isIncomeAvailable'],
    };
}

